import { patientCountColumn } from '@h20-shared/grids/columns';
import { defineGridColumns } from './column-definition';

/** A worked example of a grid column defintion  file */
export const EXAMPLE_COUNT_COLUMNS = defineGridColumns('exampleCount', [
    ['patientCount', patientCountColumn()],
]);
